export const MODEL = 'fieldborder'
export const URL = '/spatial'
export const TREE = 'fieldborderData'
export const BRANCH = 'fieldborders'

export const PROP_ID = 'id'
export const PROP_FIELD_BORDER_ID = PROP_ID
export const PROP_ASSET = 'asset'
export const PROP_SHAPE_DATA = 'shapeData'
export const PROP_TYPE = 'type'
